import { ProductType } from '@/@types';
import { Element } from '@/components/core';
import { UIComponent } from '@/components/core/components';
import clsx from 'clsx';
import { useLingui } from '@lingui/react';
import { useCallback, useEffect, useRef } from 'react';
import { useOnViewport } from '@/components/core/hooks';
import { useLayout } from '@/components/context/layout';
import { categories } from '@/@constants';
import * as styles from './product-header.styles';

const options = {
  rootMargin: '-100px 0px',
};

const ProductHeader: UIComponent<{ product: ProductType }> = ({ product, className }) => {
  const { i18n } = useLingui();
  const ref = useRef(null);
  const [, setLayout] = useLayout();
  const category = categories[product.category.name];
  const onViewportCallback = useCallback(
    (onViewport) => {
      setLayout((prev) => {
        return {
          ...prev,
          title: !onViewport ? (
            <Element lines={1} className={styles.title}>
              {product.name}
            </Element>
          ) : undefined,
        };
      });
    },
    [product, setLayout],
  );
  useOnViewport(ref, onViewportCallback, { options });

  useEffect(() => {
    return () => {
      setLayout((prev) => {
        return { ...prev, title: undefined };
      });
    };
  }, [setLayout]);
  return (
    <header ref={ref} className={clsx(styles.header, className)}>
      <Element as="h1" typography="title">
        {product.name}
      </Element>
      <Element as="h2" className={styles.subtitle}>
        <span>{i18n._(category.itemTitle)}</span> {product.releaseDate && <span>({product.releaseDate.getFullYear()})</span>}
      </Element>
    </header>
  );
};

export default ProductHeader;
